// Swiper
import {
	initDefaultSlider,
	initEffectsSlider,
	initMethodSlider,
	initProblemsSlider,
	initSolutionsSlider,
	initTeamSlider,
} from './swiper.js';

// Navigation
import { toggleNavigation, toggleSubmenu } from './navigation.js';

// Filter
import { initFilter, initLoadMore } from './ajax.js';

// Modal
import { playModalVideo, toggleModal } from './modal.js';

// Leadmagnet
import { leadmagnetForm } from './leadmagnet.js';

// Maps
import { initMap } from './maps.js';

// Animations
import { animateOnScroll } from './animations.js';

// Alpine
import './alpine';

/**
 * Auto Scale Text
 */
function wettermerkAutoScaleText() {
	('use strict');

	const textElements = document.querySelectorAll('.number--flex');

	// Abort if no elements are found.
	if (!textElements) {
		return;
	}

	const applyScaling = function (wrapper) {
		const text = wrapper.querySelector('span');
		const maxWidth = wrapper.clientWidth;
		const maxHeight = parseFloat(getComputedStyle(wrapper).maxHeight);

		// Set initial font-size.
		let fontSize = 16;
		text.style.fontSize = fontSize + 'px';

		// Increase font-size as long as it doesn't exceed the wrapper.
		while (text.clientWidth < maxWidth && text.clientHeight < maxHeight) {
			fontSize += 1;

			text.style.fontSize = fontSize + 'px';
		}

		// Reduce the font size by 1 to make sure it fits within the wrapper.
		text.style.fontSize = fontSize - 1 + 'px';

		// Show element.
		wrapper.classList.add('show');
	};

	// Create mutation observer for textContent changes.
	const mutate = function (mutations) {
		mutations.forEach(function (mutation) {
			if ('characterData' === mutation.type) {
				applyScaling(mutation.target.parentNode.parentNode);
			}
		});
	};

	const observer = new MutationObserver(mutate);
	const config = {
		characterData: true,
		attributes: true,
		childList: true,
		subtree: true,
	};

	// Apply scaling to all found textElements.
	for (const textElement of textElements) {
		applyScaling(textElement);

		observer.observe(textElement, config);
	}
}

/**
 * Get position
 */
function fixedPosition() {
	const toggle = document.querySelector('.toggle .toggle__wrapper');

	if (!toggle) {
		return;
	}

	const windowHeight = window.visualViewport.height;
	const offset = 105;

	toggle.style.top = windowHeight - offset + 'px';
}

/**
 * Toggle timeline images
 */
function toggleTimelineImages() {
	if (window.innerWidth < 768) {
		return;
	}

	const currentYear = document.querySelector('.section-timeline .year.active');

	if (!currentYear) {
		return;
	}

	const image = document.querySelector('.section-timeline .timeline__visual img');

	if (!image) {
		return;
	}

	const currentYearRect = currentYear.getBoundingClientRect();

	// Next Year.
	const nextYear = currentYear.nextElementSibling;

	if (nextYear) {
		if (currentYearRect.y + currentYearRect.height < 0) {
			currentYear.classList.remove('active');
			nextYear.classList.add('active');

			// Update image.
			const currentYearIndex = currentYear.getAttribute('data-index');
			const nextYearIndex = nextYear.getAttribute('data-index');

			document.querySelector('.section-timeline .timeline__visual img:nth-child(' + currentYearIndex + ')').classList.remove('active');
			document.querySelector('.section-timeline .timeline__visual img:nth-child(' + nextYearIndex + ')').classList.add('active');
		}
	}

	// Previous year.
	const previousYear = currentYear.previousElementSibling;

	if (previousYear) {
		const previousYearRect = previousYear.getBoundingClientRect();

		if ( previousYearRect.y + previousYearRect.height > 0 ) {
			currentYear.classList.remove('active');
			previousYear.classList.add('active');

			// Update image.
			const currentYearIndex = currentYear.getAttribute('data-index');
			const previousYearIndex = previousYear.getAttribute('data-index');

			document.querySelector('.section-timeline .timeline__visual img:nth-child(' + currentYearIndex + ')').classList.remove('active');
			document.querySelector('.section-timeline .timeline__visual img:nth-child(' + previousYearIndex + ')').classList.add('active');
		};
	}
}

/**
 * Match height of FAQ items
 */
function matchHeightFAQ() {
	if (window.innerWidth < 992) {
		return;
	}

	const questions = document.querySelectorAll('.section-faq details h5');

	if (!questions) {
		return;
	}

	let maxHeight = '';

	questions.forEach((question) => {
		if (question.scrollHeight > maxHeight) {
			maxHeight = question.scrollHeight;
		}
	});

	questions.forEach((question) => {
		question.style.height = maxHeight + 'px';
	});
}

/**
 * Trigger Calendly
 */
function triggerCalendly() {
	const toggles = document.querySelectorAll('.button-calendly');

	if (!toggles) {
		return;
	}

	toggles.forEach((toggle) => {
		toggle.addEventListener('click', (e) => {
			Calendly.initPopupWidget(
				{
					url: toggle.dataset.url,
				}
			);
		});
	});
}

document.addEventListener(
	'DOMContentLoaded',
	() => {
		initDefaultSlider();
		initProblemsSlider();
		initSolutionsSlider();
		initMethodSlider();
		initEffectsSlider();
		initTeamSlider();

		toggleNavigation();
		toggleSubmenu();

		wettermerkAutoScaleText();
		fixedPosition();
		toggleTimelineImages();
		matchHeightFAQ();

		initFilter();
		initLoadMore();

		toggleModal();
		playModalVideo();

		leadmagnetForm();

		initMap();

		animateOnScroll();

		triggerCalendly();
	},
	{ passive: true }
);

document.addEventListener(
	'scroll',
	() => {
		toggleTimelineImages();
		fixedPosition();
	},
	{ passive: true }
);
